import Api from "../../../services/Api";

function fetchChargerStatus(serialNo, startTime, endTime) {
  return Api.get(`/service/iqevse-csms/charger/v1/presence/${serialNo}?start=${startTime}&end=${endTime}`);
}

function fetchChargerMatrix(serialNo, startTime, endTime) {
  return Api.get(`/service/iqevse-csms/v1/opt-schedules/${serialNo}?start=${startTime}&end=${endTime}`);
}

export { fetchChargerStatus, fetchChargerMatrix };
